import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationAssetInspectionPerformedDto extends IGetNotification {
    assetId: Guid
    inspectionId: Guid
    reservationId: Guid
    shippingOrderId: Guid
    damages: boolean
}

export default class NotificationAssetInspectionPerformed extends Notification {
    asset: NotificationAsset
    damages: boolean

    constructor(dto: IGetNotificationAssetInspectionPerformedDto) {
        super(dto)
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
        this.damages = dto.damages
    }
}
